import React, { useContext } from "react";
import "../../../../../styles/global.css";
import { TranslationsContext } from "../../../../../utils/TranslationsContext";
import AccreditationInput from "../../../../AccreditationInput/components/Dropdown";

const TimePicker = ({ hours, setHours, minutes, setMinutes }) => {
  const { t } = useContext(TranslationsContext);
  const hourOptions = Array.from({ length: 24 }, (_, i) => {
    const label = String(i).padStart(2, "0");
    return { key: label, value: label };
  });

  const minuteOptions = ["00", "15", "30", "45"].map((m) => ({
    key: m,
    value: m,
  }));

  return (
    <div className="flex-direction-row items-center time-picker gap-4">
      <p>{t("TIME")}</p>
      <p className="font-14 inria-sans-400">:</p>
      <AccreditationInput
        options={hourOptions}
        selectedOption={hours}
        setSelectedOption={setHours}
        className="time-picker-dropdown"
        searchable={false}
        type="dropdown"
      />
      <p className="font-14 inria-sans-400">:</p>
      <AccreditationInput
        options={minuteOptions}
        selectedOption={minutes}
        setSelectedOption={setMinutes}
        className="time-picker-dropdown"
        searchable={false}
        type="dropdown"
      />
    </div>
  );
};

export default TimePicker;
